import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import AddNewButton from '../../../images/Autocode/definitionAddNewButton.svg';
import TargetDefinitionTableHeader from './TargetDefinationTable/TargetDefinitionTableHeader';
import TargetDefinitionTableBody from './TargetDefinationTable/TargetDefinitionTableBody';
import { AC_PERSONAL_FOLDER_SCOPE } from '../AutocodeConstants';

const TargetDefinitions = ({
  definitionTargetList = [],
  checkStateDefination,
  selectedFolder,
  canAddNewDefinitions,
  handleDragEnd,
  selectedWeightType,
}) => {
  return (
    <Fragment>
      {selectedFolder && selectedFolder.selectedFolder ? (
        <div
          style={{ height: 'calc(100vh - 233px)' }}
          data-test="TargetDefinitions"
        >
          <TargetDefinitionTableHeader
            allDefinitionTarget={definitionTargetList}
            selectDefination={checkStateDefination}
            selectedFolder={selectedFolder}
            canAddNewDefinitions={canAddNewDefinitions}
            selectedWeightType={selectedWeightType}
          />
          {definitionTargetList.length > 0 ? (
            <div className="ac--def--body">
              <TargetDefinitionTableBody
                allDefinitionTarget={definitionTargetList}
                selectDefination={checkStateDefination}
                selectedFolder={selectedFolder}
                handleDragEnd={handleDragEnd}
                selectedWeightType={selectedWeightType}
              />
            </div>
          ) : (
            canAddNewDefinitions &&
            (selectedFolder.selectedFolder.scope ===
              AC_PERSONAL_FOLDER_SCOPE.value1 ||
              selectedFolder.selectedFolder.scope ===
                AC_PERSONAL_FOLDER_SCOPE.value2) && (
              <div className="ac--def--empty-body">
                Click{' '}
                <img
                  src={AddNewButton}
                  alt="add new"
                  title="Add New Definiton"
                  style={{
                    marginTop: '15px',
                    marginLeft: '15px',
                  }}
                />{' '}
                to add a new definition
              </div>
            )
          )}
        </div>
      ) : (
        <div className="de--def--no-record">
          Once a folder has been selected this section will display available
          definitions.
        </div>
      )}
    </Fragment>
  );
};

TargetDefinitions.propTypes = {
  definitionTargetList: PropTypes.arrayOf(PropTypes.shape({})),
  checkStateDefination: PropTypes.func,
  selectedFolder: PropTypes.shape({
    selectedFolder: PropTypes.shape({
      scope: PropTypes.number,
    }),
  }),
  canAddNewDefinitions: PropTypes.bool,
  handleDragEnd: PropTypes.func,
  selectedWeightType: PropTypes.shape({}),
};

export default TargetDefinitions;
